// extracted by mini-css-extract-plugin
module.exports = {"actions":"StockForm_actions__1evdS"};